module.exports = __webpack_public_path__ + "img/jifen11.7e4b6670.png";